export const debounce = (func: () => void, time = 500): ReturnType<typeof setTimeout> => {
	return setTimeout(func, time);
};

export const clearDebounce = (deb: ReturnType<typeof setTimeout>): void => {
	clearTimeout(deb);
};
